import useEditCharacterItem from '../composables/useEditCharacterItem'
import useEditStaticItem from './useEditStaticItem.js'

//--------------------------------
// update character items harness
//--------------------------------
export default async function useUpdateCharacterItemsHarness(changed_items) {
  console.log('---------------------------------------')
  console.log('IN useUpdateCharacterItemsHarness')

  const results = []

  //---------------------------------------------------------------
  // 1. Apply CharacterItem updates (CRUD)
  //---------------------------------------------------------------
  for (const s of changed_items) {
    console.log('IN useUpdateCharacterItemsHarness - PROCESSING ITEM:', s)

    // DELETE always goes through CharacterItem API
    if (s.action === 'DELETE') {
      results.push(await useEditCharacterItem(s))
      continue
    }

    // UPDATE only if payload has fields
    if (s.payload && Object.keys(s.payload).length > 0) {
      results.push(await useEditCharacterItem(s))
      continue
    }

    // Preserve caller index alignment for deferred id resolution when an
    // item change becomes a no-op after temp link fields are stripped.
    results.push(null)
  }

  //---------------------------------------------------------------
  // 2a. Apply scalar static Item updates (non-image)
  //---------------------------------------------------------------
  //---------------------------------------------------------------
  // 2a. scalar static fields (race, countable, etc.)
  //---------------------------------------------------------------
  for (const itm of changed_items) {
    if (
      itm.type === 'Artefact' &&
      itm.item_id != null &&
      itm.static_updates &&
      Object.keys(itm.static_updates).length > 0
    ) {
      console.log('2a. Applying static Item updates for artefact:', itm)

      const payload = Object.fromEntries(
        Object.entries(itm.static_updates).filter(([key, value]) => {
          if (key === 'image_file') return false // ⭐ DO NOT TOUCH IMAGE FILE
          if (value === undefined) return false
          if (key === 'currency' && value === null) return false
          return true
        }),
      )

      if (Object.keys(payload).length === 0) {
        continue
      }

      try {
        await useEditStaticItem({ id: itm.item_id, payload })
      } catch (err) {
        console.error('Error updating static artefact Item', err)
        throw err
      }
    }
  }
  //--------------------------------------------------------
  // 2b. Apply image upload OR image clear for static Item
  //--------------------------------------------------------
  //---------------------------------------------------------------
  // 2b. Apply image upload OR image clear for static Item
  //---------------------------------------------------------------
  for (const itm of changed_items) {
    console.log('2b. PROCESSING ITEM FOR IMAGE UPDATE:', itm)

    if (
      itm.type === 'Artefact' &&
      itm.item_id &&
      itm.static_updates &&
      'image_file' in itm.static_updates
    ) {
      console.log('2b. Applying static Item image update for artefact:', itm.item_id)

      const fd = new FormData()

      // CLEAR IMAGE
      if (itm.static_updates.image_file === null) {
        console.log('2b. Clearing image for artefact:', itm.item_id)
        fd.append('image', '')
      }

      // UPLOAD NEW IMAGE
      else {
        console.log('2b. Uploading new image for artefact:', itm.item_id)

        // ⭐ Extract the actual File from the FormData
        const file = itm.static_updates.image_file.get('image')

        // ⭐ Append the File, not the FormData
        fd.append('image', file)
      }

      await useEditStaticItem({
        id: itm.item_id,
        payload: fd,
        isMultipart: true,
      })
    }
  }

  //---------------------------------------------------------------
  // Return CharacterItem update results
  //---------------------------------------------------------------
  return results
}
